import DataTableColumnHeader from '@/components/datatable/DataTableColumnHeader.vue';
import StatusIndicator from '@/components/StatusIndicator.vue';
import type { SalaryStatus } from '@/types';
import type { ColumnDef } from '@tanstack/vue-table';
import { h } from 'vue';

export const columns: ColumnDef<SalaryStatus>[] = [
    {
        accessorKey: 'name',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'dashboards.employee.table_company',
            }),
    },
    {
        accessorKey: 'salary_deadline',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'dashboards.employee.salary_deadline',
            }),
        filterFn: 'dateRange',
        meta: {
            filterType: 'dateRange',
        },
    },
    {
        accessorKey: 'payroll_reported',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'dashboards.employee.payroll_reported',
            }),
        cell: ({ row }) => {
            return h(StatusIndicator, {
                active: row.original.payroll_reported,
                type: 'yesNo',
            });
        },
        filterFn: 'boolean',
        meta: {
            filterType: 'yesNo',
        },
    },
    {
        accessorKey: 'pay_slips_for_approval',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'dashboards.employee.pay_slips_for_approval',
            }),
        cell: ({ row }) => {
            return h(StatusIndicator, {
                active: row.original.pay_slips_for_approval,
                type: 'yesNo',
            });
        },
        filterFn: 'boolean',
        meta: {
            filterType: 'yesNo',
        },
    },
    {
        accessorKey: 'payslips_approved',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'dashboards.employee.payslips_approved',
            }),
        cell: ({ row }) => {
            return h(StatusIndicator, {
                active: row.original.payslips_approved,
                type: 'yesNo',
            });
        },
        filterFn: 'boolean',
        meta: {
            filterType: 'yesNo',
        },
    },

    {
        accessorKey: 'payslips_sent',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'dashboards.employee.payslips_sent',
            }),
        cell: ({ row }) => {
            return h(StatusIndicator, {
                active: row.original.payslips_sent,
                type: 'yesNo',
            });
        },
        filterFn: 'boolean',
        meta: {
            filterType: 'yesNo',
        },
    },
    {
        accessorKey: 'payroll_done',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'dashboards.employee.payroll_finalized',
            }),
        cell: ({ row }) => {
            return h(StatusIndicator, {
                active: row.original.payroll_done,
                type: 'yesNo',
            });
        },
        filterFn: 'boolean',
        meta: {
            filterType: 'yesNo',
        },
    },
];
